export function getModel<TModel>(): TModel {
    return JSON.parse($("#model").html());
}